module.exports = __webpack_public_path__ + "static/media/SmallLogo.eb8ef3db.png";